import { render } from "./PasswordLogin.vue?vue&type=template&id=5c877482"
import script from "./PasswordLogin.vue?vue&type=script&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&lang=js"

import "./PasswordLogin.vue?vue&type=style&index=0&id=5c877482&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__